module.exports = __webpack_public_path__ + "@/assets/img/zones-icon.6f566a76.svg";